export const iconFontAwesomeMapsSquarePhoneFlip = (
	<i className="fa-solid fa-square-phone-flip"></i>
);
